module.exports = __webpack_public_path__ + "img/DAVID_CANNON_23-rs.686da89d.jpg";